import styled, { css, keyframes } from 'styled-components'
import { colors } from '../../../styles/GlobalVariables'

const loader = keyframes`
  0% {
    background-color: black;
  }
  100% {
    background-color: ${colors.tvGuideDark};
  }
`

export const RailItemImageWrap = styled.div`
  border-radius: 0.8125rem;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 9px 9px rgba(0, 0, 0, 0.4);
  position: relative;

  ${props =>
    props.theme.loaded
      ? ''
      : css`
          animation: ${loader} 1s linear infinite;
        `}
  transition: transform 0.5s ease;

  &:hover {
    opacity: 1;
    transform: scale(1.05);

    &:after {
      opacity: 1;
    }
  }

  ${props =>
    !props.theme.found
      ? css`
          background: linear-gradient(
            90deg,
            #06060d -34.07%,
            #171f3d 47.01%,
            #06060d 137.67%
          );

          img {
            width: 100%;
            height: 100%;
          }
        `
      : ''};
  @media only screen and (max-width: 768px) {
    height: 0;
    padding-bottom: calc(100% * 9 / 16);
    &:hover {
      opacity: 1;
      transform: none;
    }

    &:after {
      display: none;
    }
  }
`
export const RailItemImage = styled.img`
  width: 100%;
  border-radius: inherit;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media all and (max-width: 768px) {
    position: absolute;
  }
`
